<template>
  <div class="layout">
    <common-header :navArray="navArray"></common-header>
    <slot name='main'></slot>
    <div class="cle"></div>
    <common-footer></common-footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        navArray: [{
            title: "网站首页",
            url: "/index",
            id: 0,
          }, {
            title: "招考公告",
            url: "/notice",
            id: 1,
          },
          {
            title: "成绩查询",
            url: "/grade",
            id: 2,
          },

          {
            title: "报名流程",
            url: "/apply",
            id: 3,
          },
          {
            title: "个人中心",
            url: "/mine",
            id: 4,
          },
        ]

      };
    },
  }
</script>

<style lang="scss" scoped>
  .layout {
    background-color: #F7F7F7;
  }
</style>